import { ComponentProps } from "."
import Content from "./Content"
import { Actions, Wrapper } from "./styled"

const Card = ({
  actions,
  avatar,
  display,
  flagLoading,
  isShowFlagButton,
  label,
  name,
  onSelect,
  onToggleFlagged,
  selected,
  serviceName,
  subheader,
  title
}: ComponentProps) => (
  <Wrapper>
    <Content
      avatar={avatar}
      display={display}
      flagLoading={flagLoading}
      isShowFlagButton={isShowFlagButton}
      label={label}
      name={name}
      onSelect={onSelect}
      onToggleFlagged={onToggleFlagged}
      selected={selected}
      serviceName={serviceName}
      subheader={subheader}
      title={title}
    />

    <Actions>{actions}</Actions>
  </Wrapper>
)

export default Card
